module.exports = __webpack_public_path__ + "static/media/patterns.7ae3463d.svg";